import { useQuery } from '@tanstack/react-query';
import { StatusCode, getCustomerDietaryRestrictions } from '@hungryroot/rest';
import { CUSTOMER_DIETARY_RESTRICTIONS_QUERY_KEY } from '@hungryroot/rest-hooks';

const timeLimit = 15 * 60 * 1000;

export function useCustomerDietaryRestrictions(options?: {
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: CUSTOMER_DIETARY_RESTRICTIONS_QUERY_KEY,
    queryFn: async () => {
      const resp = await getCustomerDietaryRestrictions();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    retry: false,
    enabled: options?.enabled,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
